import * as React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/infra'

const alertVariants = cva(
  'relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7',
  {
    variants: {
      variant: {
        default: 'bg-background text-foreground',
        success:
          'border-green-900/10 relative rounded-lg bg-green-50 p-4 text-green-900 animate-fade-in [&>svg]:text-green-900',
        destructive:
          'border-red-900/10 relative rounded-lg bg-red-50 p-4 text-red-900 animate-fade-in [&>svg]:text-red-900',
        warning:
          'border-orange-900/10  relative rounded-lg bg-orange-50 p-4 text-orange-900 animate-fade-in [&>svg]:text-orange-900',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props} />
))
Alert.displayName = 'Alert'

const AlertTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h5 ref={ref} className={cn('mb-2 leading-none font-semibold tracking-wide', className)} {...props}>
      {props.children}
    </h5>
  ),
)
AlertTitle.displayName = 'AlertTitle'

const AlertDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('text-sm font-normal [&_p]:leading-relaxed', className)} {...props} />
  ),
)
AlertDescription.displayName = 'AlertDescription'

export { Alert, AlertTitle, AlertDescription }
